<template>
  <div align="right">
    <v-container fluid grid-list-sm>
      <v-card>
        <v-btn depressed small rounded color="success" @click="onVerify"
          >ត្រួតពិនិត្យ</v-btn
        >
        <v-btn
          depressed
          small
          rounded
          color="success"
          :disabled="saveBtnState"
          @click="onSave"
          >រក្សាទុក</v-btn
        >
        <!--
        <v-btn depressed small color="success" @click="onCancel">បោះបង់</v-btn>
        -->
      </v-card>
    </v-container>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: function () {
    return {};
  },
  computed: {
    ...mapState({
      uiCon: (state) => state.uiControl,
    }),
    saveBtnState: function () {
      let sState = this.$store.state.uiControl.schoolState;
      let fType = this.uiCon.formType;
      if (sState > fType) {
        return true; // disable SAVE button
      } else {
        return false; // enable SAVE button
      }
      // return !this.$store.state.uiControl.canSave // ! convert to boolean value
    },
  },
  methods: {
    onSave: function () {
      // 10-11-12-13 Private Pre, Pri, Sec, Compre
      // 16-17 Dis, Pro form
      if (this.uiCon.formType === 5) {
        this.$store.dispatch("pubascf/savePubAscfPre");
        //this.$store.dispatch("climate/saveClimate");
      } else if (this.uiCon.formType === 6) {
        this.$store.dispatch("pubascf/savePubAscfPri");
        //this.$store.dispatch("climate/saveClimate");
      } else if (this.uiCon.formType === 7) {
        this.$store.dispatch("pubascf/savePubAscfSec");
        //this.$store.dispatch("climate/saveClimate");
      } else if (this.uiCon.formType === 10) {
        this.$store.dispatch("privascf/savePrivAscfPre");
      } else if (this.uiCon.formType === 11) {
        this.$store.dispatch("privascf/savePrivAscfPri");
      } else if (this.uiCon.formType === 12) {
        this.$store.dispatch("privascf/savePrivAscfSec");
      } else if (this.uiCon.formType === 13) {
        this.$store.dispatch("compre/saveCompre");
      } else if (this.uiCon.formType === 16) {
        // District Form, pd_code is 4 digits BUT MUST Enter ZERO after for working, pf is Zero
        this.$store.dispatch("prodis/saveProDis", {
          acc_code: this.ac_code,
          pd_code: this.sc_code,
          ipf: 0,
        });
      } else if (this.uiCon.formType === 17) {
        // Provincial Form, pd_code is 2 digits BUT MUST Enter ZERO after for working, pf is One
        this.$store.dispatch("prodis/saveProDis", {
          acc_code: this.ac_code,
          pd_code: this.sc_code,
          ipf: 1,
        });
      } else if (this.uiCon.formType === 22) {
        this.$store.dispatch("wins/saveWins");
      } else if (this.uiCon.formType === 28) {
        this.$store.dispatch("textbook/saveTextbookPri");
      } else if (this.uiCon.formType === 29) {
        this.$store.dispatch("textbook/saveTextbookSec");
      } else if (this.uiCon.formType === 34) {
        this.$store.dispatch("puqemispri/saveQEMISpri");
      } else if (this.uiCon.formType === 35) {
        this.$store.dispatch("puqemissec/saveQEMISsec");
      }
    },
    onVerify: function () {
      if (this.uiCon.formType === 5) {
        this.$store.dispatch("pubascf/verifyPubAscfPre");
      } else if (this.uiCon.formType === 6) {
        this.$store.dispatch("pubascf/verifyPubAscfPri");
      } else if (this.uiCon.formType === 7) {
        this.$store.dispatch("pubascf/verifyPubAscfSec");
      } else if (this.uiCon.formType === 10) {
        this.$store.dispatch("privascf/verifyPrivAscfPre");
      } else if (this.uiCon.formType === 11) {
        this.$store.dispatch("privascf/verifyPrivAscfPri");
      } else if (this.uiCon.formType === 12) {
        this.$store.dispatch("privascf/verifyPrivAscfSec");
      } else if (this.uiCon.formType === 13) {
        this.$store.dispatch("compre/verifyCommunityPre");
      }
    },
    onCancel: function () {
      console.log("cancel");
    },
  },
};
</script>

